import { useAppDispatch, useAppSelector } from '../store/hooks';
import {
  loginRequest,
  registerRequest,
  logoutRequest,
  getCurrentUserRequest,
  updateProfileRequest,
  changePasswordRequest,
  forgotPasswordRequest,
  resetPasswordRequest,
  clearError,
} from '../store/slices/authSlice';
import { LoginRequest, RegisterRequest, UpdateProfileRequest, ChangePasswordRequest } from '../services/authService';
import { RootState } from '../store';

export const useAuth = () => {
  const dispatch = useAppDispatch();
  const { user, isAuthenticated, isLoading, error, token, refreshToken } = useAppSelector((state: RootState) => state.auth);

  const login = (credentials: LoginRequest) => {
    dispatch(loginRequest(credentials));
  };

  const register = (userData: RegisterRequest) => {
    dispatch(registerRequest(userData));
  };

  const logout = () => {
    dispatch(logoutRequest());
  };

  const getCurrentUser = () => {
    dispatch(getCurrentUserRequest());
  };

  const updateProfile = (updates: UpdateProfileRequest) => {
    dispatch(updateProfileRequest(updates));
  };

  const changePassword = (passwordData: ChangePasswordRequest) => {
    dispatch(changePasswordRequest(passwordData));
  };

  const forgotPassword = (email: string) => {
    dispatch(forgotPasswordRequest(email));
  };

  const resetPassword = (token: string, newPassword: string) => {
    dispatch(resetPasswordRequest({ token, newPassword }));
  };

  const clearAuthError = () => {
    dispatch(clearError());
  };

  return {
    // State
    user,
    isAuthenticated,
    isLoading,
    error,
    token,
    refreshToken,

    // Actions
    login,
    register,
    logout,
    getCurrentUser,
    updateProfile,
    changePassword,
    forgotPassword,
    resetPassword,
    clearAuthError,
  };
};
